
import React, { useState, useEffect, useRef } from "react"
import { toast } from "react-toastify"
import { useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"

import { Button } from "components"
import { editOfflineOrder } from "@redux"
import classes from "./OfflineOrderDetailCancelModalFooter.module.scss"
import clsx from "clsx"

const OfflineOrderDetailCancelModalFooter = props => {
  const {
    form,
    total,
    offlineOrder,
    setOfflineOrder,
    setFormErrors,
    setShowConfirmationModal,
    initialFormErrorsState
  } = props

  const [t, i18n] = useTranslation()

  const dispatch = useDispatch()

  const [sending, setSending] = useState(false)

  const unmount = useRef(false)

  const validate = () => {
    let result = true
    const errors = { ...initialFormErrorsState }

    if (form.cancelReasons.length > 300) {
      result = false
      errors.cancelReasons = t("دلیل_لغو_سفارش_طولانی_است")
    }

    setFormErrors(errors)

    return result
  }

  const handleOfflineCancel = async () => {
    if (!validate()) return

    setSending(true)

    try {
      dispatch(
        editOfflineOrder(
          offlineOrder.offlineOrderId,
          {
            orderStatus: "canceled",
            cancelReasons: form.cancelReasons,
            refundType: form.refundType
          }
        )
      )

      setOfflineOrder(prev => ({
        ...prev,
        orderStatus: "canceled",
        cancelReasons: form.cancelReasons,
        refundType: form.refundType
      }))

      setShowConfirmationModal(false)
    } catch (err) {
      console.log(err)

      toast.error(t("سفارش_لغو_نشد"))

      setSending(false)
    }
  }

  useEffect(() => {
    unmount.current = false

    return () => unmount.current = true
  }, [])

  const disableApproveButton =
    offlineOrder.orderStatus === "paid" &&
    Number(total) !== Number(form.amount)

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["buttonContainer"]}>
      <Button
        color="danger"
        disabled={sending}
        onClick={() => setShowConfirmationModal(false)}
      >
        {t("خیر")}
      </Button>

      <Button
        color="success"
        loading={sending}
        disabled={disableApproveButton}
        onClick={handleOfflineCancel}
        className={clsx(
          classes["yesButton"],
          isLtr && classes["yesButton-ltr"]
        )}
      >
        {t("بله")}
      </Button>
    </div>
  )
}

export default OfflineOrderDetailCancelModalFooter